import { render, staticRenderFns } from "./statusInfo.vue?vue&type=template&id=c2e887fa&"
import script from "./statusInfo.vue?vue&type=script&lang=js&"
export * from "./statusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports